export const ROLL_OWNER = 10
export const ROLL_ADMIN = 20
export const ROLL_MANAGER = 30
export const ROLL_ADMIN_SUPPORT = 35
export const ROLL_ASSISTANT = 40
export const ROLL_PRODUCER = 50
export const ROLL_STAFF = 60
export const ROLL_AGENCY_MONITOR = 70

export const IW_ALLOWED_ROLLS = [ROLL_OWNER, ROLL_ADMIN];
export const STAFF_DASHBOARD_ROLLS = [ROLL_STAFF, ROLL_PRODUCER];
export const ADMIN_DASHBOARD_ALLOWED_ROLLS = [
    ROLL_OWNER, ROLL_ADMIN, ROLL_MANAGER, ROLL_ADMIN_SUPPORT, ROLL_ASSISTANT
];

export const getHashParameter = (param) => {
    const hash = window.location.hash;
    const hashParam = hash.split('?');
    if (hashParam[1]) {
        // get parameters and their values only
        let pageURL = decodeURIComponent(hashParam[1]);
        let params = pageURL.split('&');
        for (let i = 0; i < params.length; i++) {
            let paramVars = params[i].split('=');

            if (paramVars[0] === param) {
                return paramVars[1] === undefined ? 0 : paramVars[1];
            }
        }
    }
    return 0;
}

export const downloadPDF = (content, fileName) => {
    let binary = atob(content);
    let len = binary.length;
    let buffer = new ArrayBuffer(len);
    let view = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
    }
    let pdfBlob = new Blob([view], {type: "application/pdf"});
    let downloadUrl = window.URL.createObjectURL(pdfBlob);

    // Handle IE and firefox issue
    if (navigator.appVersion.toString().indexOf('.NET') > 0)
        window.navigator.msSaveBlob(pdfBlob, fileName);
    else {
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.setAttribute('download', fileName);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
}

export const ordinalSuffix = (i) => {
    let j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return "st";
    }
    if (j == 2 && k != 12) {
        return "nd";
    }
    if (j == 3 && k != 13) {
        return "rd";
    }
    return "th";
}

// Function names used in Access permission
export const AGENCY_PROFILE = 1
export const MANAGE_USERS = 2
export const DEPARTMENT = 3
export const JOB_TITLE = 4
export const P_L_ITEMS = 5
export const P_L_EXPENSE = 6
export const AGENCY_REVENUE = 7
export const AGENCY_REVENUE_GOAL = 8
export const JOB_DESCRIPTION = 9
export const MASTER_KPI_LIST = 10
export const COMPENSATION_PROFILE = 11
export const STAFF_DATA = 12
export const ACHIEVEMENT_CORRECTION = 13
export const CLOCK_OUT_REASONS = 14
export const SEND_MESSAGE = 15
export const TIME_SHEET = 16
export const PEER_EVALUATION = 17
export const COMPLIANCE_AUDIT = 18
export const ORGANIC_GROWTH_WIZARD = 19
export const REPORT = 20
export const DAILY_ACTIVITY_REPORT = 20
export const AGENCY_PERFORMANCE_REPORT = 21
export const COMMISSION_REPORT = 22
export const COMPENSATION_AGREEMENT = 23
export const KPI_REPORT = 24
export const INSTALLATION_WIZARD = 25
export const KPI_PLANNING = 26
export const AGENCY_MONITOR = 27
export const STAFF_SALES = 28
export const PTO_SETTINGS = 29
export const PTO_REQUEST = 30
export const PRODUCER_COMPENSATION_FUNCTION = 31
export const ADMIN_DASHBOARD = 32
export const PERFORMANCE_EVALUATION = 33
export const STAFF_DATA_REPORT = 34
export const KPI_EXPLANATION_REPORT = 35
export const TIME_SHEET_REPORT = 36
export const MANUAL_IMPORT_MAP_COLUMNS = 37
export const KPI_IN_COMPENSATION_PROFILE = 38 
export const TOGGLE_STAFF_ACCESS = 39
export const INCOME_SECTION = 40 
export const HOURLY_SALARY = 41
export const COMMISSION_REVENUE = 42 
export const ACTIVITY_CODE = 43
export const SICK_LEAVE_REQUEST = 44


// WEBPACK FOOTER //
// ./src/components/common/Constants.js